export default __webpack_public_path__ + "static/media/fontRoboto900_cyrillic.ae912a40.woff2";